<template>
  <div class="nch--blog-category">
    <div class="nch--blog-container">
      <Card class="nch--blog-content">
        <Breadcrumb :items="breadcrumb" />
        <Header :value="category"></Header>
        <Posts :value="category" />
      </Card>
      <Aside/>
    </div>
  </div>
</template>

<script>
import Card from '../../common/Card';
import Breadcrumb from '../../common/Breadcrumb';
import Header from './Header';
import Posts from './Posts';
import Aside from '../../Aside';
import theme from '../../../mixins/theme';

export default {
  name: 'Category',
  components: {
    Card,
    Breadcrumb,
    Header,
    Posts,
    Aside,
  },
  mixins: [
    theme,
  ],
  props: {
    value: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({
        title: 'Blog',
      }),
    },
  },
  data() {
    return {
      breadcrumb: [
        { name: this.settings.title, href: '/blog' },
      ],
    };
  },
  computed: {
    category() {
      return this.value;
    },
  },
};
</script>
<style scoped>
.nch--blog-category{
  display: flex;
  align-items: center;
  justify-content: center;
}
.nch--blog-container {
  display: grid;
  width: var(--blog-container-width);
  grid-template-columns: 1fr auto;
  grid-template-areas: "content aside";
}
.nch--blog-content{
  display: flex;
  flex-direction: column;
}
@media (max-width: 900px) {
  .nch--blog-container {
    display: flex;
    flex-direction: column;
  }
}
</style>
<style>
.nch--blog-category * {
  font-family: var(--blog-font-family);
}
</style>
